import { ChangeDetectionStrategy, Component } from "@angular/core";
import { Observable } from "rxjs";
import { SocialMediaService } from "./social-media.service";

@Component({
  selector: "app-icon-linkedin",
  template: `<a
                href="{{ url | async }}"
                target="_blank"
                class="fab fa-linkedin-in"></a>`,
  styleUrls: ["./icon-social-media.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IconLinkedinComponent {

  constructor(
    private readonly socialMediaService: SocialMediaService
  ) { }

  get url(): Observable<string> {
    return this.socialMediaService.linkedinUrl$;
  }
}
